export const formatPercentage = (value: number | null): string => {
	const safeValue = value ?? 0
	return `${Math.min(100, Math.max(0, Number(safeValue)))}%`
}
